// extracted by mini-css-extract-plugin
export default {"counter":"AgentCounter_counter__RVK04","current":"AgentCounter_current__9GYLH","separator":"AgentCounter_separator__7DTEW","total":"AgentCounter_total__KCqiA"};